import { IPostBankAccount } from "interfaces/IBankAccount";

/**
 * Assures the input text is only numbers
 * @param input - The input string to be checked
 * @returns A string containing only the numbers from the input
 */
export const onlyNumbers = (input: string): string => {
    return input.replace(/[^0-9]/g, '');
};

/**
 * Function that validates what type of account number was prompted
 */
export const validateAccountNumber = (input: string, bankAccount: IPostBankAccount): IPostBankAccount | undefined => {
    const curedInput = input.replaceAll('-', "");
    const inputLength = curedInput.length;
    switch (inputLength) {
        case 10: return { ...bankAccount, account_number: curedInput };
        case 11: return { ...bankAccount, account_number: curedInput };
        case 16: return { ...bankAccount, card_number: curedInput };
        case 18: return { ...bankAccount, clabe: curedInput };
        case 20: return { ...bankAccount, clabe: curedInput };
        default: return undefined;
    }
}

/**
 * Formats the number to a card number for easier reading
 */
export const formatCardNumber = (cardNumber: string) => {
    let dashedNumber = "";
    if (cardNumber.length === 16) {
        const split = cardNumber.split("");
        split.forEach((x, index) =>

            dashedNumber += ((index + 1) % 4 == 0) ? `${x}-` : x
        );
        return dashedNumber.substring(0, dashedNumber.length - 1);
    }
    return cardNumber;
}

/**
 * Currency format for numbers related to prices
 */
const formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
});
/**
 * A method that process a number to format it to a money quantity
 */
export const currencyMXN = (value: number) => (formatter.format(value));

/**
 * Method that truncates the decimal part of a number
 */
export const truncateNumber = (number: string | number) => {
    const normalize = Number(number);
    return Math.trunc(normalize);
}